import React, { useEffect, useState } from "react";
import {
  Container,
  Card,
  Row,
  Col,
  Form,
  ButtonGroup,
  Button,
  Modal,
} from "react-bootstrap";
import PageTitle from "../components/common/PageTitle";
import { useTranslation } from "react-i18next";

import api from "../api/api";
import swal from "sweetalert";
import Pagination from "../views/Pagination";
import "./ConfigurationManagement.css";

const ConfigurationIrrigation = () => {
  const [irrigationsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const [SearchName, setSearchName] = useState("");

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const { t } = useTranslation();

  const [allIrrigations, setAllIrrigations] = useState([]);

  const [irrigationData, setIrrigationData] = useState({
    irrigation: "",
    pivotShape: "",
    lateral: "",
    effIrrig: "",
  });

  const [checked, setChecked] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [toggleEdit, setToggleEdit] = useState(false);
  const [singleIrrig, setSingleIrrig] = useState({});

  const getIrrigations = async () => {
    try {
      await api
        .get("/irrigations/get-irrigations")
        .then((response) => {
          let listIrrigations = response.data.Irrigations;
          setAllIrrigations(listIrrigations);
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getIrrigations();
  }, []);

  const getSingleIrrig = (irrigationId, title) => {
    let data = {
      irrigation_id: irrigationId,
    };

    api
      .post("/irrigations/get-irrigation", data)
      .then((res) => {
        let IrrigationData = res.data.irrigation;
        setSingleIrrig(IrrigationData);
        setIrrigationData({
          irrigation: IrrigationData.irrigation,
          pivotShape: IrrigationData.pivotShape,
          lateral: IrrigationData.lateral,
          effIrrig: IrrigationData.effIrrig,
        });
      })
      .catch((error) => {
        swal({
          title: t("Error"),
          icon: "error",
        });
      });
    if (title === "Edit") {
      setToggleEdit(!toggleEdit);
    }
  };

  const addIrrigations = () => {
    let data = {
      irrigation: irrigationData.irrigation,
      pivot_shape: irrigationData.pivotShape,
      lateral: irrigationData.lateral,
      effIrrig: irrigationData.effIrrig,
    };

    api
      .post("/irrigations/add-irrigations", data)
      .then((response) => {
        if (response && response.data.type === "success") {
          swal(`${t("irrigation_added")}`, { icon: "success" });
          setToggle(false);
          getIrrigations();
        }
        if (response && response.data.type === "danger") {
          swal(`${t("Saving Irrigation Error")}`, { icon: "error" });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleEdit = (irrigationId) => {
    let data = {
      irrigation_id: irrigationId,
      irrigation: irrigationData.irrigation,
      pivot_shape: irrigationData.pivotShape,
      lateral: irrigationData.lateral,
      effIrrig: irrigationData.effIrrig,
    };

    api
      .post("/irrigations/edit-irrigation", data)
      .then((response) => {
        if (response.data.type == "success") {
          swal(t("Irrigation has been updated"), {
            icon: "success",
          });
          setToggleEdit(false);
          getIrrigations();
        }
        if (response.data.type && response.data.type == "danger") {
          swal({
            icon: "error",
            title: t("Oops..."),
            text: t("error_edit_irrigation"),
          });
          return false;
        }
      })
      .catch((error) => {
        swal({
          icon: "error",
          title: t("Oops..."),
          text: t("error_edit_irrigation"),
        });
      });
  };

  const handleDelete = async (irrigationId) => {
    let data = {
      irrigation_id: irrigationId,
    };
    return await api
      .delete("/irrigations/delete-irrigation", { data: data })
      .then((response) => {
        if (response.data.type && response.data.type == "danger") {
          swal({
            title: t("Cannot Delete irrigation"),
            icon: "warning",
          });
          return false;
        }
        if (response.data.type == "success") {
          getIrrigations();
          return true;
        }
        return false;
      })
      .catch((error) => {
        swal({
          title: t("Cannot Delete irrigation"),
          icon: "error",
          text: t("error_delete_irrigation"),
        });
        return false;
      });
  };

  const confirmDelete = (irrigationId) => {
    swal({
      title: t("Are you sure?"),
      text: t("Once deleted, you will not be able to recover this irrigation!"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then(async (Delete) => {
        if (Delete) {
          const deleted = await handleDelete(irrigationId);
          if (deleted) {
            swal(t("Irrigation has been deleted!"), {
              icon: "success",
            });
          }
        }
      })
      .catch((error) => {
        swal({
          title: t("Cannot Delete irrigation"),
          icon: "error",
          text: t("error_delete_irrigation"),
        });
      });
  };

  const IrrigationPropsByType = () => {
    switch (irrigationData.irrigation) {
      case "Pivot":
        return (
          <Col lg="6" md="12" sm="12">
            <Form.Group className="d-flex justify-content-center align-items-center flex-column">
              <label htmlFor="pivotShape"></label>
              <Form.Select
                id="pivotShape"
                value={irrigationData.pivotShape}
                onChange={(e) =>
                  setIrrigationData({
                    ...irrigationData,
                    pivotShape: e.target.value,
                  })
                }
              >
                <option value="">{t("Select type")}</option>
                <option value="circular">{t("Circular")}</option>
                <option value="semi_circular">{t("Semi circular")}</option>
              </Form.Select>
            </Form.Group>
          </Col>
        );
      case "Lateral":
        return (
          <Col lg="6" md="12" sm="12">
            <Form.Group className="d-flex justify-content-center align-items-center flex-column">
              <label htmlFor="lateral"></label>
              <Form.Select
                id="lateral"
                value={irrigationData.lateral}
                onChange={(e) =>
                  setIrrigationData({
                    ...irrigationData,
                    lateral: e.target.value,
                  })
                }
              >
                <option value="">{t("Select type")}</option>
                <option value="lateral_ns">{t("Lateral NS")}</option>
                <option value="lateral_ew">{t("Lateral EW")}</option>
              </Form.Select>
            </Form.Group>
          </Col>
        );
      default:
        return null;
    }
  };

  const filteredIrrigations = allIrrigations.filter((irrigations) => {
    if (SearchName !== "") {
      return irrigations.irrigation
        .toLowerCase()
        .includes(SearchName.toLowerCase());
    }
    return irrigations;
  });

  const indexOfLastPost = currentPage * irrigationsPerPage;
  const indexOfFirstPost = indexOfLastPost - irrigationsPerPage;
  const currentIrrigations = filteredIrrigations.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  return (
    <>
      <Container className="management-page admin-management-page configuration-management-page p-4">
        <Row noGutters className="page-header py-4">
          <PageTitle
            sm="4"
            title={t("Irrigations Configuration")}
            subtitle={t("Irrigations Configuration")}
            className="text-sm-left"
          />
        </Row>
        <Row>
          <PageTitle sm="4" subtitle={t("search")} className="text-sm-left" />
        </Row>
        <Row form className="d-flex justify-content-center">
          <Col md="3" className="form-group">
            <Form.Group>
              <div className="d-flex">
                <Form.Control
                  value={SearchName}
                  onChange={(e) => setSearchName(e.target.value)}
                  id="search"
                  placeholder={t("Search By Name")}
                />
              </div>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <PageTitle
            sm="4"
            subtitle={t("my actions")}
            className="text-sm-left"
          />
        </Row>
        <Row form className="py-2 d-flex justify-content-center">
          <ButtonGroup>
            <Button
              variant="outline-primary"
              onClick={() => {
                setToggle(true);
              }}
            >
              {t("Add Irrigations Type")}
            </Button>
          </ButtonGroup>
        </Row>
        <Card>
          <Card.Header className="border-bottom">
            <div>
              <h5>{t("Irrigations Info")}</h5>
            </div>
          </Card.Header>
          <Card.Body>
            <table className="table mb-0 text-center  table-responsive-lg">
              <thead className="bg-light">
                <tr>
                  <th scope="col" className="border-0">
                    {t("Irrigation_Type")}
                  </th>
                  <th scope="col" className="border-0">
                    {t("Pivot shape")}
                  </th>
                  <th scope="col" className="border-0">
                    {t("Lateral")}
                  </th>
                  <th scope="col" className="border-0"></th>
                </tr>
              </thead>
              <tbody>
                {currentIrrigations.map((irrigation) => {
                  return (
                    <tr key={irrigation.id}>
                      <td>{t(irrigation.irrigation)}</td>
                      <td>{irrigation.pivot_shape}</td>
                      <td>{irrigation.lateral}</td>
                      <td>
                        <ButtonGroup size="sm" className="mr-2 configuration-action-group">
                          <Button
                            title={t("Edit")}
                            onClick={() => {
                              getSingleIrrig(irrigation.id, "Edit");
                            }}
                            className="configuration-action-button"
                          >
                            <i className="fas fa-pen" aria-hidden="true" />
                          </Button>
                          <Button
                            title={t("Delete")}
                            onClick={() => {
                              confirmDelete(irrigation.id);
                            }}
                            className="configuration-action-button"
                            variant="danger"
                          >
                            <i className="fas fa-trash" aria-hidden="true" />
                          </Button>
                        </ButtonGroup>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Card.Body>
        </Card>
        <Row className="py-4 justify-content-center">
          <Pagination
            usersPerPage={irrigationsPerPage}
            totalUsers={filteredIrrigations.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </Row>
      </Container>
      <Modal size="lg" centered={true} show={toggle} onHide={() => setToggle(false)}>
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              width: "100%",
            }}
          >
            <Button
              // theme="success"
              onClick={() => {
                addIrrigations();
              }}
              className="mb-2 mr-1 btn btn-success"
            >
              <i className="fa fa-check mx-2"></i>
              {t("save")}
            </Button>
            <Button
              // theme="success"
              className="mb-2 mr-1 btn btn-danger"
              onClick={() => {
                setToggle(false);
              }}
            >
              <i className="fa fa-times mx-2"></i>
              {t("cancel")}
            </Button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col lg="12" md="12" sm="12">
              <Card.Body>
                <Row className="gap-2 justify-content-between">
                  <Col lg="6" md="12" sm="12">
                    <Form.Group>
                      <label htmlFor="irrig">{t("Irrigation_Type")}</label>
                      <Form.Select
                        id="irrig"
                        value={irrigationData.irrigation}
                        onChange={(e) =>
                          setIrrigationData({
                            ...irrigationData,
                            irrigation: e.target.value,
                          })
                        }
                      >
                        <option value="">{t("Select_type")}</option>
                        {[
                          "Pivot",
                          "Drip",
                          "Lateral",
                          "Furrow",
                          "SDI",
                          "Sprinkler",
                        ].map((irrig) => {
                          return <option value={irrig}>{irrig}</option>;
                        })}
                      </Form.Select>
                      <input
                        type="checkbox"
                        name="Autre"
                        id="check"
                        onClick={() => setChecked(!checked)}
                      />{" "}
                      {t("other")}
                      {checked ? (
                        <Form.Control
                          value={irrigationData.irrigation}
                          placeholder={t("Irrigation")}
                          onChange={(e) =>
                            setIrrigationData({
                              ...irrigationData,
                              irrigation: e.target.value,
                            })
                          }
                        />
                      ) : (
                        ""
                      )}
                    </Form.Group>
                  </Col>

                  <Col lg="5" md="12" sm="12">
                    <Form.Group>
                      <label htmlFor="effIrrig">
                        {t("efficience_irrigation")}
                      </label>
                      <Form.Control
                        id="effIrrig"
                        style={{ height: "39px" }}
                        value={irrigationData.effIrrig}
                        onChange={(e) =>
                          setIrrigationData({
                            ...irrigationData,
                            effIrrig: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  {IrrigationPropsByType()}

                  {/* <Col lg='3' md="12" sm="12">

                            <Form.Group className='d-flex justify-content-center align-items-center flex-column'>
                                <label htmlFor="Fc"></label>
                                <Form.Control
                                    id='Fc'
                                 
                                />
                            </Form.Group>
                            </Col>

                            <Col lg='4' md="12" sm="12">

                            <Form.Group className='d-flex justify-content-center align-items-center flex-column'>
                                <label htmlFor="taw"></label>
                                <Form.Control
                                    id='taw'
                                  
                                />
                            </Form.Group>
                            </Col> */}
                </Row>

                <Form.Group>
                  <label htmlFor="feDescription">{t("desc")}</label>
                  <Form.Control
                    as="textarea"
                    placeholder={t("desc")}
                    id="feDescription"
                    rows="5"
                  />
                </Form.Group>
              </Card.Body>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <Modal size="lg" centered={true} show={toggleEdit} onHide={() => setToggleEdit(false)}>
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              width: "100%",
            }}
          >
            <Button
              // theme="success"
              onClick={() => {
                handleEdit(singleIrrig.id);
              }}
              className="mb-2 mr-1 btn btn-success"
            >
              <i className="fa fa-check mx-2"></i>
              {t("save")}
            </Button>
            <Button
              // theme="success"
              className="mb-2 mr-1 btn btn-danger"
              onClick={() => {
                setToggleEdit(false);
              }}
            >
              <i className="fa fa-times mx-2"></i>
              {t("cancel")}
            </Button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col lg="12" md="12" sm="12">
              <Card.Body>
                <Row>
                  <Col lg="6" md="12" sm="12">
                    <Form.Group>
                      <label htmlFor="irrig">{t("Irrigation_Type")}</label>
                      <Form.Select
                        id="irrig"
                        value={irrigationData.irrigation}
                        onChange={(e) =>
                          setIrrigationData({
                            ...irrigationData,
                            irrigation: e.target.value,
                          })
                        }
                      >
                        <option value="">{t("Select_type")}</option>
                        {[
                          "Pivot",
                          "Drip",
                          "Lateral",
                          "Furrow",
                          "SDI",
                          "Sprinkler",
                        ].map((irrig) => {
                          return <option value={irrig}>{irrig}</option>;
                        })}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col lg="6" md="12" sm="12">
                    <Form.Group>
                      <label htmlFor="effIrrig">
                        {t("efficience_irrigation")}
                      </label>
                      <Form.Control
                        id="effIrrig"
                        value={irrigationData.effIrrig}
                        onChange={(e) =>
                          setIrrigationData({
                            ...irrigationData,
                            effIrrig: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>{IrrigationPropsByType()}</Row>

                <Form.Group>
                  <label htmlFor="feDescription">{t("desc")}</label>
                  <Form.Control
                    as="textarea"
                    placeholder={t("desc")}
                    id="feDescription"
                    rows="5"
                  />
                </Form.Group>
              </Card.Body>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ConfigurationIrrigation;
